import actionTypes from '../../actions/actionTypes'
import { Map, fromJS } from 'immutable'
import { returnStateIfNoAction } from '../helpers'
import { PROGRAM_DEFAULT } from '../../constants/state'


const INIT_STATE = fromJS(PROGRAM_DEFAULT.elbenwaldBrandMappings)

const create = (state, action) => {
    return state.setIn(['items', action.payload.pk], Map({
        meta: action.payload.meta,
        brand: action.payload.brand,
    }))
}


const elbenwaldBrandMappingsReducer = (state = INIT_STATE, action) => {

    returnStateIfNoAction(action, state)

    switch(action.type) {
        // case actionTypes.BRAND_MOVIE_MAPPINGS_CREATE_ITEM:
        //     return create(state, action)
        default:
            return state;
    }
}

export default elbenwaldBrandMappingsReducer